import { type Qualification } from "../types";

export function getQualificationLabel(name: string, qualifications: Qualification[]): string {
  const qualification = qualifications.find(({ attributes }) => attributes.name === name);
  return qualification?.attributes.displayLabel ?? name;
}
